<div>
    <nav class="navigation-bar">
        <div class="hamburger"(click)="toggleNavbar()">
                <button mat-icon-button  [matMenuTriggerFor]="menu">
                    <mat-icon>menu</mat-icon>
                </button>
        </div>
            <span class="company-logo">
                <a routerLink="/home"> 
                    <img class="factory-logo" [src]="factoryLogo" alt="Image preview" />
                </a>
            </span> 
                <ul class="navbar-links">
                    <li *ngFor="let link of navLinks">
                        <a href="#" routerLinkActive="active" [routerLink]="link.route" >{{ link.label }}</a>
                    </li>
                </ul>
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngFor="let link of navLinks" [routerLink]="link.route">
            {{ link.label }}
          </button>
      </mat-menu>
    </nav>
</div> 

